import { NavLink, useNavigate } from 'react-router-dom';
import { sessao } from './api';
import { Icone } from './Icones.jsx';

export default function Layout({ children }) {
  const nav = useNavigate();
  const u = sessao.usuario;
  if (!u) return null;

  const admin = u.perfil === 'admin';
  const itens = [
    (admin || u.perms?.ver_relatorios) && ['/dashboard', 'Dashboard', 'dashboard'],
    (admin || u.perms?.criar_os) && ['/nova-os', 'Nova OS', 'novaos'],
    ['/ordens', 'Ordens de Serviço', 'ordens'],
    (admin || u.perms?.alterar_status) && ['/expedicao', 'Expedição', 'expedicao'],
    (admin || u.perms?.ver_relatorios) && ['/relatorios', 'Relatórios', 'relatorios'],
    admin && ['/lojas', 'Lojas', 'lojas'],
    admin && ['/fornecedores', 'Fornecedores', 'caminhao'],
    (admin || u.perms?.gerenciar_usuarios) && ['/usuarios', 'Usuários', 'usuarios'],
    admin && ['/formas', 'Formas de Armação', 'formas'],
  ].filter(Boolean);

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="logo">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/logo.png" alt="" style={{ width: 30 }} />
            <div style={{ fontWeight: 900, fontSize: 16 }}>LAB<span style={{ color: '#ffb27a' }}> Morais</span></div>
          </div>
        </div>
        <nav>
          {itens.map(([to, label, ic]) => (
            <NavLink key={to} to={to} className={({ isActive }) => isActive ? 'ativo' : ''}
              style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
              <Icone nome={ic} size={16} />{label}
            </NavLink>
          ))}
        </nav>
        <div style={{ marginTop: 'auto', padding: 14, borderTop: '1px solid rgba(255,255,255,.12)' }}>
          <div style={{ fontSize: 13, fontWeight: 800 }}>{u.nome}</div>
          <div style={{ fontSize: 11.5, opacity: .7, marginBottom: 8 }}>
            {u.perfil === 'admin' ? 'Administrador' : u.perfil === 'expedicao' ? 'Expedição' : `Atendente · ${u.loja_nome || ''}`}
          </div>
          <button className="btn-sec" style={{ color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}
            onClick={() => { sessao.sair(); nav('/login'); }}>Sair</button>
        </div>
      </aside>
      <main className="conteudo">{children}</main>
    </div>
  );
}
